import React from 'react'

import { Close, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

function TermChip({ label, removeLabel, onRemove }) {
  const handleRemove = () => onRemove(label)

  return (
    <span className="search-within__term cgt-body-base">
      {label}
      <button
        type="button"
        className="search-within__term-remove"
        aria-label={removeLabel}
        onClick={handleRemove}
      >
        <Icon notSpaced svgComponent={Close} size="small" color="darker" className="search-within__term-icon" />
      </button>
    </span>
  )
}

TermChip.propTypes = {
  label: string.isRequired,
  removeLabel: string.isRequired,
  onRemove: func.isRequired,
}

export default TermChip
